import { useLocale } from "../i18n/LocaleContext";
import { buildLocalizedPath } from "../lib/siteRouting";
import { BrandLogo } from "./BrandLogo";

export function Footer() {
  const { copy, locale } = useLocale();
  const nav = copy.header.nav.filter((item) =>
    ["#brands", "#about", "#ai-solutions", "#network", "#contact"].includes(item.href)
  );

  return (
    <footer className="px-5 pb-12 pt-1 sm:px-8 lg:px-12">
      <div className="mx-auto flex max-w-7xl flex-col gap-5 rounded-[2.85rem] border border-[#dbe8ef] bg-[linear-gradient(180deg,rgba(252,254,255,0.74),rgba(239,246,249,0.8))] px-6 py-7 text-sm text-soft/66 shadow-[0_10px_20px_rgba(103,131,145,0.04)] backdrop-blur sm:px-7 lg:flex-row lg:items-end lg:justify-between">
        <div className="space-y-3">
          <div className="flex items-center gap-4">
            <BrandLogo size="sm" className="shrink-0" />
            <div>
              <div className="font-display text-[0.98rem] font-semibold tracking-[0.18em] text-[#1f2b31]">
                QIANDU 千渡
              </div>
              <div className="mt-1 text-[8px] uppercase tracking-[0.34em] text-soft/40">{copy.footer.tag}</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-[9px] uppercase tracking-[0.24em] text-soft/42">
            {nav.map((item) => (
              <a key={item.href} href={item.href} className="transition hover:text-[#6f9cab]">
                {item.label}
              </a>
            ))}
            <a href={buildLocalizedPath(locale, "/company/verification")} className="transition hover:text-[#6f9cab]">
              {locale === "zh" ? "企业核验" : locale === "ko" ? "기업 확인" : locale === "vi" ? "Xác minh" : "Company verification"}
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-1 text-right sm:items-end">
          <a href="mailto:service@qiandu.group" className="text-[0.96rem] text-[#1f2b31] transition hover:text-[#6f9cab]">
            service@qiandu.group
          </a>
          <div className="text-[10px] tracking-[0.18em] text-soft/44">{copy.footer.copyright}</div>
          <div className="max-w-md text-[9px] leading-5 text-soft/40">
            {locale === "zh" ? "韩国法人：주식회사 천도그룹 · 仁川注册总部" : locale === "ko" ? "한국 법인: 주식회사 천도그룹 · 인천 등록 본점" : locale === "vi" ? "Pháp nhân Hàn Quốc: 주식회사 천도그룹 · Trụ sở đăng ký tại Incheon" : "Korean legal entity: 주식회사 천도그룹 · Registered headquarters in Incheon"}
          </div>
        </div>
      </div>
    </footer>
  );
}
